import type { CrmHistoryEventMap } from '@/Containers/CrmSection/Components/History'

/**
 * Коди подій історії заявки — рівно enum беку
 * `backend/web/src/Containers/ApplicationContainer/Database/Enum/ApplicationHistoryEvent.php`
 * (`SPEC-021` §4.7, Q2.5). `application_returned_to_work` немає — Q2.11.
 *
 * Ключі — **буквальні** повні коди: мапу звіряє з беком вартовий «кожен код
 * події історії з бека має підпис на фронті»
 * (`Ship/Helpers/architectureGuard.test.ts`). Підписи й тони — `SPEC-021` §4.7.
 */
export const APPLICATION_HISTORY_EVENT_MAP: CrmHistoryEventMap = {
    application_created: { label: 'Заявку створено', tone: 'blue', kind: 'created' },
    application_status_changed: { label: 'Змінено статус', tone: 'neutral', kind: 'status' },
    application_lost: { label: 'Заявку програно', tone: 'red', kind: 'status' },
    application_problem_reported: { label: 'Проблемне замовлення', tone: 'red', kind: 'status' },
    application_problem_resolved: { label: 'Проблема вирішена', tone: 'green', kind: 'status' },
    application_profit_calculated: { label: 'Пораховано прибуток', tone: 'neutral', kind: 'updated' },
    application_removed: { label: 'Заявку видалено', tone: 'red', kind: 'removed' },
    application_document_generated: { label: 'Згенеровано документ', tone: 'neutral', kind: 'document' },
    application_document_edited: { label: 'Документ змінено в редакторі', tone: 'neutral', kind: 'document' },
}
